<div class="toast-container position-fixed  p-3" style="z-index: 1200; right: 0;top: 100px;" *ngIf="toastService.show">
    <div class="toast show border-0 shadow-lg rounded-4 overflow-hidden" role="alert" aria-live="assertive"
        aria-atomic="true" style="background-color: #8a1538; color: white;">
        <!-- Toast Header -->
        <div class="toast-header d-flex justify-content-between align-items-center px-3 py-2" style="
          background-color: #8a1538;
          color: white;
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        ">
            <div class="d-flex align-items-center">
                <i [ngClass]="[toastService.type === 'success' ? 'pi pi-check-circle': 'pi pi-times-circle'] "
                    style="font-size: 1.2rem; margin-right: 0.5rem;"></i>


                <strong>
                    {{'Fields.documentProcessStatus'| translate}}
                </strong>
            </div>

            <button type="button" class="btn-close btn-close-white" aria-label="Close"
                (click)="toastService.hideToast()"></button>
        </div>

        <!-- Toast Body -->
        <div class="toast-body bg-white text-start py-3 px-4">
            <p class="mb-0 fw-semibold" [ngStyle]="{
            color: toastService.type === 'success' ? '#198754' : '#dc3545'
          }">
                {{ toastService.message| translate }}
            </p>
        </div>
    </div>
</div>